module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.0d1e127f.jpg";